module.exports = __webpack_public_path__ + "img/save.a6ea77e4.svg";